import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { CountdownBar } from './components/CountdownBar';
import { RocketLaunch } from './components/RocketLaunch';
const BenefitsSection = lazy(() => import('./components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const MethodSection = lazy(() => import('./components/MethodSection').then(m => ({
  default: m.MethodSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const FooterSection = lazy(() => import('./components/FooterSection').then(m => ({
  default: m.FooterSection
})));
export function App() {
  useEffect(() => {
    document.title = 'Estrategias Digitales AZ';
    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'A‑Z convertimos ideas en páginas que generan clientes. Creamos landing pages premium a medida en tiempo récord.';
    // Open Graph tags (WhatsApp, Facebook, etc.)
    const ogTags: Record<string, string> = {
      'og:title': 'Estrategias Digitales AZ',
      'og:description': 'A‑Z convertimos ideas en páginas que generan clientes. Creamos landing pages premium a medida en tiempo récord.',
      'og:type': 'website',
      'og:image': 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <div className="min-h-screen bg-[#050510] text-white selection:bg-purple-500 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <Suspense fallback={null} data-id="element-4">
          <BenefitsSection data-id="element-5" />
          <TestimonialsSection data-id="element-6" />
          <MethodSection data-id="element-7" />
          <PricingSection data-id="element-8" />
          <FAQSection data-id="element-9" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-10">
        <FooterSection data-id="element-11" />
      </Suspense>
      <CountdownBar data-id="element-12" />
      <RocketLaunch data-id="element-13" />
    </div>;
}